export const buildPriceFormat = (price) => {
    const formater = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }); 

    return formater.format(price);
}